import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function HotArticles() {
  const hotArticles = articles.slice(0, 4);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          热门评测文章
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          深度评测各大免费看片平台，帮你快速做出最佳选择
        </p>
      </div>
      <div className="space-y-4">
        {hotArticles.map((article) => (
          <ArticleCard key={article.id} {...article} />
        ))}
      </div>
    </section>
  );
}